import backend, {NOTIFICATION_API} from 'utils/backend/server/api_library';

const sendNotification = (userRn, jobRn, jobTitle, weeklyPay) => {
  const body = {
    type: 'NEW_JOB_POSTING',
    params: {
      jobRn,
      jobTitle,
      weeklyPay,
    },
  };

  const url = `${NOTIFICATION_API}/user/${userRn}/send_notification`;
  return backend.post(url, body);
};

const getUserEmails = (userRn) => {
  const url = `${NOTIFICATION_API}/user/${userRn}/email`;
  return backend.get(url);
};

const createUserEmail = (userRn, email) => {
  const url = `${NOTIFICATION_API}/user/${userRn}/email`;
  const body = {
    email,
  };
  return backend.post(url, body);
};

const removeUserEmail = (userRn, email) => {
  const url = `${NOTIFICATION_API}/user/${userRn}/email`;
  const body = {
    email,
  };
  return backend.delete(url, body);
};

export default {
  sendNotification,
  getUserEmails,
  createUserEmail,
  removeUserEmail,
};
